import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { HelpCircle } from "lucide-react";

export function HelpTip({ text, title, testid = "help-tip" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.preventDefault()}
          className="inline-flex items-center justify-center text-muted-foreground hover:text-emerald-500 transition-colors align-middle ml-1"
          data-testid={testid}
          aria-label="Help"
        >
          <HelpCircle className="w-3.5 h-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64" side="top" data-testid={`${testid}-content`}>
        {title && <p className="font-semibold text-sm mb-1">{title}</p>}
        <p className="text-muted-foreground text-xs leading-relaxed">{text}</p>
      </PopoverContent>
    </Popover>
  );
}
